import Enumerator from '../global/Enumerator';

export const contactCreditScoreTypes = ['equifax', 'illion'];

export class ContactCreditScoreType extends Enumerator {
  static default() {
    return this.of('equifax');
  }

  static of(option?: string) {
    return this.enumValueOf(option) || this.default();
  }
}

ContactCreditScoreType.initEnum({
  equifax: {
    get title() {
      return 'Equifax';
    }
  },
  illion: {
    get title() {
      return 'Illion';
    }
  }
});

export default {
  contactCreditScoreTypes,
  ContactCreditScoreType
};
